export const HotjarEvents = {
    ProfileChanged: 'profile-changed-successfully',
    ProfilePictureChanged: 'profile-picture-uploaded',
    PasswordChanged: 'profile-password-changed',
};
